class UpgradeTeaser {
  constructor($uibModal) {
    this.$uibModal = $uibModal
    this.config = {}
  }

  setConfig(config) {
    this.config = config
  }

  openModal() {
    const template = this.config.template || 'upgrade-teaser.partial.html'

    var modalInstance = this.$uibModal.open({
      animation   : true,
      templateUrl : template,
      controller  : 'UpgradeTeaserController',
      controllerAs: 'utc',
    })
    
    modalInstance.config = this.config
  }
}

UpgradeTeaser.$inject = ['$uibModal']

export default UpgradeTeaser